export default __webpack_public_path__ + "src/images/packages/villa-54-victoria/8ff2ebf8570cce063c73580ce9c1688b-2.jpg";